import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const GroupsModule = React.lazy(() => import("./GroupsModule"));
const GroupsOverviewPage = React.lazy(() => import("./page/GroupsOverviewPage/GroupsOverviewPage"));
const GroupsSegmentsPage = React.lazy(() => import("./page/GroupsSegmentsPage/GroupsSegmentsPage"));
const GroupsOccasionsPage = React.lazy(() => import("./page/GroupsOccasionsPage/GroupsOccasionsPage"));
const GroupsNeedsPage = React.lazy(() => import("./page/GroupsNeedsPage/GroupsNeedsPage"));
const GroupsQualQuestionPage = React.lazy(
  () => import("./page/GroupsQualQuestionPage/GroupsQualQuestionPage"),
);
const GroupsTextQuestionPage = React.lazy(
  () => import("./page/GroupsTextQuestionPage/GroupsTextQuestionPage"),
);
const GroupsTestOptionPage = React.lazy(() => import("./page/GroupsTestOptionPage/GroupsTestOptionPage"));
const UandAPage = React.lazy(() => import("./page/UandAPage/UandAPage"));

export const GroupsModuleRoutes: RouteObject = {
  path: ":clientId/groups/:projectGroupId/*",
  element: <PageRoute El={GroupsModule} />,
  children: [
    {
      path: "segments",
      element: <PageRoute El={GroupsSegmentsPage} />,
    },
    {
      path: "occasions",
      element: <PageRoute El={GroupsOccasionsPage} />,
    },
    {
      path: "needs",
      element: <PageRoute El={GroupsNeedsPage} />,
    },
    {
      path: ":tab?",
      element: <PageRoute El={GroupsOverviewPage} />,
    },
    {
      path: "qual/:questionId",
      element: <PageRoute El={GroupsQualQuestionPage} />,
    },
    {
      path: "text/:questionId",
      element: <PageRoute El={GroupsTextQuestionPage} />,
    },
    {
      path: "test-options/:tab",
      element: <PageRoute El={GroupsTestOptionPage} />,
    },
    {
      path: "u-and-a",
      element: <PageRoute El={UandAPage} />,
    },
  ],
};
